<template>
  <div v-if="teamId">
    <HfTooltip
      :label="title"
      position="is-right"
      class="is-info"
    >
      <HfTeamLogo
        :team-id="teamId"
        :figure-container="false"
      />
    </HfTooltip>
  </div>
</template>

<script setup lang="ts">
  import {computed, ref} from 'vue';
  import HfTeamLogo from '@/components/shared/HfTeamLogo.vue';
  import HfTooltip from '@/components/ui/HfTooltip.vue';
  import TEAM_SERVICE from '@/services/team.service';
  import {RendererProps} from '@/components/stats/renderer/renderer.model';

  const props = defineProps<{
    props: RendererProps;
  }>();

  const teamId = computed(() => props.props.value ? String(props.props.value) : '');
  const seasonId = computed(() => props.props.data.seasonId ? String(props.props.data.seasonId) : '');
  const leagueId = computed(() => props.props.data.leagueId ? String(props.props.data.leagueId) : '');

  const title = ref('');

  if (!teamId.value) {
    title.value = 'n/a';
  } else if (!seasonId.value || !leagueId.value) {
    title.value = teamId.value.toUpperCase();
  } else {
    TEAM_SERVICE.teamById(teamId.value, seasonId.value, leagueId.value)
      .then(resp => {
        title.value = resp.data.longName;
      })
      .catch(() => {
        // the failed request is already reported by the http service
        title.value = teamId.value.toUpperCase();
      });
  }
</script>
